export enum PresetFilterName {
  ITZEHOER_WITHOUT_GARAGE_BINDING = "withoutGarageBinding",
  ITZEHOER_WITH_GARAGE_BINDING = "withGarageBinding",
  SIXT_RISK = "risk",
  SIXT_BUY_BACK = "buyBack",
}
